/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionPlanDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createPagedResultOfCommissionPlanDtoFromDiscriminatorValue, serializeCommissionPlanDto, serializeCreateCommissionPlanRequest, type CommissionPlanDto, type CreateCommissionPlanRequest, type ErrorResponse, type InternalErrorResponse, type PagedResultOfCommissionPlanDto } from '../../../models/index.js';
// @ts-ignore
import { ActiveRequestBuilderNavigationMetadata, type ActiveRequestBuilder } from './active/index.js';
// @ts-ignore
import { type WithCommissionPlanItemRequestBuilder, WithCommissionPlanItemRequestBuilderNavigationMetadata, WithCommissionPlanItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/plans
 */
export interface PlansRequestBuilder extends BaseRequestBuilder<PlansRequestBuilder> {
    /**
     * The active property
     */
    get active(): ActiveRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.commissions.plans.item collection
     * @param commissionPlanId Unique identifier of the item
     * @returns {WithCommissionPlanItemRequestBuilder}
     */
     byCommissionPlanId(commissionPlanId: string) : WithCommissionPlanItemRequestBuilder;
    /**
     * Returns every plan in the organization, switched on or off — filter on `active` to narrow it. Plans are not filtered by effective date either, so a listing includes ones that have expired and ones that have not started. Sorting defaults to name ascending, and each plan comes back with its rules and overrides in full rather than as a summary.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfCommissionPlanDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<PlansRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfCommissionPlanDto | undefined>;
    /**
     * Every rate is a fraction between 0 and 1 — send 0.05 for 5%, not 5 — and anything outside that range is rejected. Rules are tried by ascending priority and the first to match a line sets its rate, so put a catch-all last; a line matching no rule earns the default rate. A customer override replaces the plan's rules outright for that customer rather than adding to them. Rules and overrides are fixed at creation: the update endpoint cannot change them, so a plan whose rules need to change is replaced by a new one. A plan is identified by its sales rep and name together, so creating a second plan with the same pair is refused; give it a different name. New plans are created active.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionPlanDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionPlanDto | undefined>;
    /**
     * Returns every plan in the organization, switched on or off — filter on `active` to narrow it. Plans are not filtered by effective date either, so a listing includes ones that have expired and ones that have not started. Sorting defaults to name ascending, and each plan comes back with its rules and overrides in full rather than as a summary.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PlansRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Every rate is a fraction between 0 and 1 — send 0.05 for 5%, not 5 — and anything outside that range is rejected. Rules are tried by ascending priority and the first to match a line sets its rate, so put a catch-all last; a line matching no rule earns the default rate. A customer override replaces the plan's rules outright for that customer rather than adding to them. Rules and overrides are fixed at creation: the update endpoint cannot change them, so a plan whose rules need to change is replaced by a new one. A plan is identified by its sales rep and name together, so creating a second plan with the same pair is refused; give it a different name. New plans are created active.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateCommissionPlanRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns every plan in the organization, switched on or off — filter on `active` to narrow it. Plans are not filtered by effective date either, so a listing includes ones that have expired and ones that have not started. Sorting defaults to name ascending, and each plan comes back with its rules and overrides in full rather than as a summary.
 */
export interface PlansRequestBuilderGetQueryParameters {
    filters?: string[];
    pageNumber?: number;
    pageSize?: number;
    sortDirection?: string;
    sortOn?: string;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const PlansRequestBuilderUriTemplate = "{+baseurl}/api/commissions/plans?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&filters*,useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PlansRequestBuilderNavigationMetadata: Record<Exclude<keyof PlansRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCommissionPlanId: {
        requestsMetadata: WithCommissionPlanItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithCommissionPlanItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["commissionPlanId"],
    },
    active: {
        navigationMetadata: ActiveRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PlansRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PlansRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfCommissionPlanDtoFromDiscriminatorValue,
    },
    post: {
        uriTemplate: PlansRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionPlanDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateCommissionPlanRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
